import { PreferencesFormFields } from "../components";

export type SectionErrors = {
  roles?: string;
  technologies?: string;
  countries?: string;
  solarSize?: string;
  solarStages?: string;
  bessSize?: string;
  bessStages?: string;
};

type ValidationResult = {
  isValid: boolean;
  error?: string;
};

export const validateRoles = (formValues: PreferencesFormFields): ValidationResult => {
  if ((formValues.activity_interests?.length ?? 0) === 0) {
    return { isValid: false, error: 'Please select at least one role' };
  }
  return { isValid: true };
};

export const validateTechnologies = (formValues: PreferencesFormFields): ValidationResult => {
  if ((formValues.technology_interests?.length ?? 0) === 0 && !formValues.other_technology?.trim()) {
    return { isValid: false, error: 'Please select at least one technology' };
  }
  return { isValid: true };
};

export const validateCountries = (formValues: PreferencesFormFields): ValidationResult => {
  if ((formValues.countries_interests?.length ?? 0) === 0 && !formValues.location_interests?.trim()) {
    return { isValid: false, error: 'Please select at least one country' };
  }
  return { isValid: true };
};

export const validateSolarSize = (formValues: PreferencesFormFields): ValidationResult => {
  const minValue = formValues.solar_size?.[0]?.trim();
  const maxValue = formValues.solar_size?.[1]?.trim();

  return isValidSize(minValue, maxValue);
};

export const validateSolarStages = (formValues: PreferencesFormFields): ValidationResult => {
  if ((formValues.solar_development_status?.length ?? 0) === 0) {
    return { isValid: false, error: 'Please select at least one development stage' };
  }
  return { isValid: true };
};

export const validateBessSize = (formValues: PreferencesFormFields): ValidationResult => {
   const minValue = formValues.bess_size?.[0]?.trim();
   const maxValue = formValues.bess_size?.[1]?.trim();
  
   return isValidSize(minValue, maxValue);
};

export const validateBessStages = (formValues: PreferencesFormFields): ValidationResult => {
  if ((formValues.development_status_interests?.length ?? 0) === 0) {
    return { isValid: false, error: 'Please select at least one development stage' };
  }
  return { isValid: true };
};

const isValidSize = (minValue: string | undefined, maxValue: string | undefined): ValidationResult => {
   if (!minValue || !maxValue) {
     return { isValid: false, error: 'Please enter both project size values' };
   };
   if (minValue.length > 5 || maxValue.length > 5) {
     return { isValid: false, error: 'Values cannot exceed 5 digits' };
   };

   const minNum = parseInt(minValue);
   const maxNum = parseInt(maxValue);
   if (minNum > maxNum) {
     return { isValid: false, error: 'Minimum value must be less than maximum value' };
   };

   return { isValid: true };
};
